import { gql } from '@apollo/client';

const templateFields = `
    id
    body
    footer
    label
    isHsm
    updatedAt
    translations
    type
    quality
    category
    language {
      id
      label
      locale
    }
`;

export const GET_TEMPLATES_COUNT = gql`
  query countSessionTemplates($filter: SessionTemplateFilter!) {
    countSessionTemplates(filter: $filter)
  }
`;

export const FILTER_TEMPLATES = gql`
  query sessionTemplates($filter: SessionTemplateFilter!, $opts: Opts!) {
    sessionTemplates(filter: $filter, opts: $opts) {
      ${templateFields}
      bspId
      shortcode
      status
      reason
      isReserved
      isActive
      numberParameters
      hasButtons
      buttons
      buttonType
      tag {
        id
        label
      }
      MessageMedia {
        id
        caption
        sourceUrl
      }
    }
  }
`;

export const FILTER_SESSION_TEMPLATES = gql`
  query sessionTemplates($filter: SessionTemplateFilter!, $opts: Opts!) {
    sessionTemplates(filter: $filter, opts: $opts) {
     ${templateFields}
    }
  }
`;

export const GET_TEMPLATE = gql`
  query getsessionTemplate($id: ID!) {
    sessionTemplate(id: $id) {
      sessionTemplate {
        ${templateFields}
        isActive
        type
        MessageMedia {
          id
          caption
          sourceUrl
        }
        tag {
          id
          label
        }
        category
        shortcode
        example
        hasButtons
        buttons
        buttonType
      }
    }
  }
`;

export const GET_HSM_CATEGORIES = gql`
  query {
    whatsappHsmCategories
  }
`;

export const TEMPLATE_LIBRARY = gql`
  query templateLibrary {
    templateLibrary {
      elementName
      category
      body
      languageCode
      industry
      topic
      usecase
      containerMeta
    }
  }
`;
export const GET_SHORTCODES = gql`
  query sessionTemplates($filter: SessionTemplateFilter!) {
    sessionTemplates(filter: $filter) {
      shortcode
    }
  }
`;

export const GET_SPEED_SEND = gql`
  query SessionTemplate($id: ID!) {
    sessionTemplate(id: $id) {
      sessionTemplate {
        id
        body
        isActive
        label
        translations
        type
        language {
          id
          label
        }
        messageMedia {
          id
          caption
          sourceUrl
        }
      }
    }
  }
`;
